import { FunctionComponent, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TinyAccordion from './TinyAccordion';
import { Tooltip } from '@mui/material';

interface CollapsibleCopyableDetailsProps {
  headerText: string;
  message: string;
}

const CollapsibleCopyableDetails: FunctionComponent<CollapsibleCopyableDetailsProps> = ({ headerText, message }) => {
  const handleCopyClick = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(message);
      console.log('Text successfully copied to clipboard');
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }, [message]);

  return (
    <TinyAccordion headerText={headerText}>
      <TextField
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        value={message}
        InputProps={{
          style: {
            fontFamily: "'Monaco', 'Courier New', monospace",
            fontSize: '0.8rem',
          },
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Copy">
                <IconButton edge="end" onClick={handleCopyClick}>
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        }}
      />
    </TinyAccordion>
  );
};

export default CollapsibleCopyableDetails;
